import * as React from 'react';
import styled from 'styled-components';

const TabContent = styled.div`
  flex: 1 1;
  height: 1px;
  overflow: auto;
  max-width: 600px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export interface ITabPaneWrapperProps {
  children: React.ReactNode;
}

const TabPaneWrapper = ({ children }: ITabPaneWrapperProps) => (
  <Container>
    <TabContent>{children}</TabContent>
  </Container>
);

export default TabPaneWrapper;
